import React from 'react';

export default function VesselHistory() {
  return <div>Vesel History</div>;
}
